<div class="row page-header">
    <div class="col-12">
        <h1>Incident Investigation <small>Safety department incident reporting and investigation</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="activeTab" (activeIdChange)="tabChanged()" class="nav-tabs mb-3">
        @if (canViewDashboard) {
            <li [ngbNavItem]="0" [destroyOnHide]="false">
                <a ngbNavLink>Dashboard</a>
            </li>
        }
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Records</a>
        </li>
    </ul>

    @if (canViewDashboard) {
        <div [hidden]="!isDashboardTab">
            <app-incident-investigation-dashboard></app-incident-investigation-dashboard>
        </div>
    }

    <div [hidden]="!isRecordsTab">
        <app-incident-investigation-list></app-incident-investigation-list>
    </div>
</div>
